import { render, staticRenderFns } from "./Mountain.vue?vue&type=template&id=8c1776d4&scoped=true&"
import script from "./Mountain.vue?vue&type=script&lang=js&"
export * from "./Mountain.vue?vue&type=script&lang=js&"
import style0 from "./Mountain.vue?vue&type=style&index=0&id=8c1776d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1776d4",
  null
  
)

export default component.exports